// Which AutoJobs modes still offer "Upload Local Files" next to the Google Drive folder. ONE place: to change the scope, change this list.
//
// single and mbl_hbl: a local file goes to the server's parse-document, in the same request shape as a file from Google Drive, so both sources give the
// same result.
// manifest, bundled, invoices: REMOVED 2026-11-05. A local file was parsed in the browser (parseAirManifestExcel, parseHBLExcel, parseChineseInvoiceExcel,
// parseInvoiceBoxTemplate) and the same file from Drive on the server, and the two disagree (a manifest from Drive gets its EORI from column I, from the
// local upload it did not). See docs/go_live_checklist.md section 8 before putting any of them back.
export const LOCAL_UPLOAD_MODES: readonly string[] = ['single', 'mbl_hbl']

export function supportsLocalUpload(mode: string | null | undefined): boolean {
  return !!mode && LOCAL_UPLOAD_MODES.includes(mode)
}
